import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '@components/shared/Icon';
import Tooltip from '@components/shared/Tooltip';

const icons = {
  comment: 'comment',
  favorite: 'heart',
  like: 'like'
};

const ActionIcon = ({
  type,
  isActive,
  className,
  onClick,
  tooltip,
  disabled
}) => {
  const Wrapper = tooltip ? Tooltip : React.Fragment;
  const wrapperProps = {};

  if (tooltip) {
    wrapperProps.content = tooltip;
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={classNames(
        'action-icon',
        {
          'action-icon--active': isActive,
          [`action-icon--${type}`]: type
        },
        className
      )}
      onClick={onClick}
    >
      <Wrapper {...wrapperProps}>
        <Icon icon={icons[type]} className="action-icon__icon" />
      </Wrapper>
    </button>
  );
};

ActionIcon.defaultProps = {
  active: false,
  disabled: false
};

ActionIcon.propTypes = {
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  type: PropTypes.oneOf(['favorite', 'comment', 'like']).isRequired
};

export default ActionIcon;
